import { IUser } from '../user/types';

// Action Types
export enum Types {
  LOAD_CUSTOMER_USERS = 'customerUser/LOAD_CUSTOMER_USERS',
  LOAD_CUSTOMER_USERS_SUCCESS = 'customerUser/LOAD_CUSTOMER_USERS_SUCCESS',
  LOAD_CUSTOMER_USERS_FAILURE = 'customerUser/LOAD_CUSTOMER_USERS_FAILURE',

  CREATE_CUSTOMER_USER = 'customerUser/CREATE_CUSTOMER_USER',
  CREATE_CUSTOMER_USER_SUCCESS = 'customerUser/CREATE_CUSTOMER_USER_SUCCESS',
  CREATE_CUSTOMER_USER_FAILURE = 'customerUser/CREATE_CUSTOMER_USER_FAILURE',

  UPDATE_CUSTOMER_USER_PERMISSION = 'customerUser/UPDATE_CUSTOMER_USER_PERMISSION',
  UPDATE_CUSTOMER_USER_PERMISSION_SUCCESS = 'customerUser/UPDATE_CUSTOMER_USER_PERMISSION_SUCCESS',
  UPDATE_CUSTOMER_USER_PERMISSION_FAILURE = 'customerUser/UPDATE_CUSTOMER_USER_PERMISSION_FAILURE',
  CLEAN_ERROR_FROM_CUSTOMER_USER = 'customerUser/CLEAN_ERROR_FROM_CUSTOMER_USER',

  REMOVE_CUSTOMER_USER = 'customerUser/REMOVE_CUSTOMER_USER',
  REMOVE_CUSTOMER_USER_SUCCESS = 'customerUser/REMOVE_CUSTOMER_USER_SUCCESS',
  REMOVE_CUSTOMER_USER_FAILURE = 'customerUser/REMOVE_CUSTOMER_USER_FAILURE',

  CLEAN_ERRORS = 'customerUser/CLEAN_ERRORS'
}

export interface IAccessManagementState {
  customerUsers: ICustomerUser[];

  // createCustomerUserMessage?: string;
  loadingCreateCustomerUser: boolean;
  errorCreateCustomerUser: boolean;

  loadingRemoveUser: boolean;
  errorRemoveUser: boolean;
  // removeCustomerUserMessage?: string;
}

export interface ICustomerUser {
  customerId: string;
  loadingUsers: boolean;
  errorUsers: boolean;
  users: ICustomerUserState[];
}

export interface ICustomerUserState extends IUser {
  loadingUpdateUser: boolean;
  errorUpdateUser: boolean;
  updateUserMessage?: string;
  showRemoveUserMessage?: boolean;
}
